module.exports = __webpack_public_path__ + "img/byeomap_lightgrey.d158647c.png";